module.exports = __webpack_public_path__ + "media/images/page/ttl_pattern-6e17e5ca9fc450703d86e0b3ba708540.svg";